import { MyQueryParamsModel } from 'src/app/core/models/my-query-params.model';

export class MobileRoutesHelper {
  static readonly separatorPath = '/';

  public static getParams(withOrigin = true, url?: string): MyQueryParamsModel {
    const queryParams = {};
    let urlParams: URLSearchParams;
    if (!url) {
      urlParams = new URLSearchParams(window.location.search);
    }

    if (url) {
      urlParams = new URLSearchParams(url);
    }

    const invitation = urlParams.get('invitation');
    const from = urlParams.get('from');
    const origin = urlParams.get('origin');
    const recordSubtype = urlParams.get('recordSubtype');
    const recordSubtypeOther = urlParams.get('recordSubtypeOther');
    const itemId = urlParams.get('itemId');
    const redirectTo = urlParams.get('redirectTo');
    const product_tour_id = urlParams.get('product_tour_id');
    const locale = urlParams.get('locale');
    const lang = urlParams.get('lang');
    if (!!invitation && invitation.length > 0) {
      queryParams['invitation'] = invitation;
    }
    if (!!from && from.length > 0) {
      queryParams['from'] = from;
    }
    if (!!origin && origin.length > 0 && withOrigin) {
      queryParams['origin'] = origin;
    } else if (withOrigin) {
      queryParams['origin'] = window.location.pathname;
    }
    if (!!recordSubtype && recordSubtype.length > 0) {
      queryParams['recordSubtype'] = recordSubtype;
    }
    if (!!recordSubtypeOther && recordSubtypeOther.length > 0) {
      queryParams['recordSubtypeOther'] = recordSubtypeOther;
    }
    if (!!itemId && itemId.length > 0) {
      queryParams['itemId'] = itemId;
    }
    if (!!redirectTo && redirectTo.length > 0) {
      queryParams['redirectTo'] = redirectTo;
    }
    if (!!product_tour_id && product_tour_id.length > 0) {
      queryParams['product_tour_id'] = product_tour_id;
    }
    if (!!locale && locale.length > 0) {
      queryParams['locale'] = locale;
    }
    if (!!lang && lang.length > 0) {
      queryParams['lang'] = lang;
    }
    return queryParams;
  }
}
